import React, { useState } from 'react'
import { Button, Radio, Space } from 'antd';
import { useCookies } from 'react-cookie'
import { useDispatch, useSelector } from 'react-redux';
import { changePrivacy } from '../../../Redux/features/User/userSlice';



const EmailAlert = () => {
  const { user } = useSelector(state => state.user)
  const [mobile, setMobile] = useState(user.privacy.mobile)
  const [email, setEmail] = useState(user.privacy.email)
  const [whatsApp, setWhatsApp] = useState(user.privacy.whatsApp)
  const [dob, setDob] = useState(user.privacy.dob)
  const [annualIncome, setAnnualIncome] = useState(user.privacy.annualIncome)
  // eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
  let data = {
    header: cookies['x-auth-token'],
  }
  const dispatch = useDispatch();


  const handleUpdate = () => {
    dispatch(changePrivacy({ ...data, ...{ mobile, email, dob, annualIncome, whatsApp } }));
  }
  // const handleReset = () => {
  //   setMobile(true)
  //   setEmail(true)
  //   setDob(true)
  //   setAnnualIncome(true)
  // }
  return (
    <div>
      <div className='PrivacyHeading'>My Alerts Manager</div>
      <div className='mainEmailComp backgroundLight'>
        <div className='mainEmailComp2'>
          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Mobile Number</div>
            </div>
            <div className='col-md-5'>
              <Radio.Group onChange={(e) => setMobile(e.target.value)} value={mobile} >
                <Space direction="vertical">
                  <Radio value="premium">Visible to all Premium Members</Radio>
                  <Radio value="likeAndPremium">Visible to Premium Members you wish to connect to</Radio>
                  <Radio value="hide">Hide my Mobile Number</Radio>
                  <Radio value="like">Visible to all your Matches</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>


          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>WhatsApp Number</div>
            </div>
            <div className='col-md-5'>
              <Radio.Group onChange={(e) => setWhatsApp(e.target.value)} value={whatsApp} >
                <Space direction="vertical">
                  <Radio value="premium">Visible to all Premium Members</Radio>
                  <Radio value="likeAndPremium">Visible to Premium Members you wish to connect to</Radio>
                  <Radio value="hide">Hide my Mobile Number</Radio>
                  <Radio value="like">Visible to all your Matches</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>
          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Email</div>
            </div>
            <div className='col-md-5'>
              <Radio.Group onChange={(e) => setEmail(e.target.value)} value={email} >
                <Space direction="vertical">
                  <Radio value="premium">Visible to all Premium Members</Radio>
                  <Radio value="likeAndPremium">Visible to Premium Members you wish to connect to</Radio>
                  <Radio value="hide">Hide my Email Address</Radio>
                  <Radio value="like">Visible to all your Matches</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>

          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Date of Birth</div>
            </div>
            <div className='col-md-5'>
              <Radio.Group onChange={(e) => setDob(e.target.value === "Visible" ? true : false)} value={dob ? "Visible" : "Hide"} >
                <Space direction="vertical">
                  <Radio value="Visible">Visible</Radio>
                  <Radio value="Hide">Hide</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>

          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Annual Income</div>
            </div>
            <div className='col-md-5'>
              <Radio.Group onChange={(e) => setAnnualIncome(e.target.value === "Visible" ? true : false)} value={annualIncome ? "Visible" : "Hide"} >
                <Space direction="vertical">
                  <Radio value="Visible">Visible</Radio>
                  <Radio value="Hide">Hide</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>

        </div>

        <div className='borderBottom'></div>
        <div className='buttons'>
          <Button type="primary" onClick={handleUpdate}>Save</Button>
          {/* <Button onClick={handleReset}>Reset</Button> */}
        </div>
      </div>
    </div >
  )
}

export default EmailAlert
